import { render } from "./maternity.vue?vue&type=template&id=10806134&scoped=true"
import script from "./maternity.vue?vue&type=script&lang=js"
export * from "./maternity.vue?vue&type=script&lang=js"

import "./maternity.vue?vue&type=style&index=0&id=10806134&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10806134"]])

export default __exports__